<template>
  <div>
    <div style="overflow: hidden;">
      <img
        class="preImage"
        v-for="(item, index) in singleReceiptImgList"
        :key="index"
        :src="item.src"
        @click="showImg(index)"
      />
      <previewer :list="singleReceiptImgList" ref="previewer"></previewer>
      <div class="submitButton" @click="goUserFrame()">重新签署</div>
    </div>
  </div>
</template>

<script>
import { Previewer } from "vux";
import { getClientDetail } from "@/api/client";
export default {
  name: "frameShow",
  components: {
    Previewer
  },
  data() {
    return {
      singleReceiptImgList: [],
      userInfo: ""
    };
  },
  activated() {
    this.getUserInfo();
  },
  methods: {
    getUserInfo() {
      this.singleReceiptImgList = [];
      getClientDetail()
        .then(res => {
          this.userInfo = res;
          this.singleReceiptImgList.push({
            src: this.userInfo.frameRes.image[0].fullPath,
            msrc: this.userInfo.frameRes.image[0].fullPath
          });
        })
        .catch(err => {
          this.$showError(err);
        });
    },
    showImg(index) {
      this.$refs.previewer.show(index);
    },
    goUserFrame() {
      this.$router.push("/user/userFrame");
    }
  }
};
</script>

<style scoped>
.submitButton {
  height: 88px;
  line-height: 88px;
  text-align: center;
  color: #fff;
  background-color: #007bec;
  font-size: 15px;
  margin: 70px 20px;
  border-radius: 10px;
}
.preImage {
  width: 100%;
  height: 100%;
  display: block;
}
</style>
